export enum CHARGER_RATE {
    LOW = "3.7kW",
    MEDIUM_LOW = "7.4kW",
    MEDIUM = "11kW",
    MEDIUM_HIGH = "22kW",
    HIGH = "43kW",
}
